import styled, {css} from 'styled-components'
import {ButtonNavLink} from '@components/ui/button-nav-link/ButtonNavLink.tsx'

export const StyledNavbar = styled.nav(
    ({theme: {spacing, palette}}) => css`
        display: grid;
        grid-template-rows: minmax(0, 1fr) auto;
        padding: ${spacing * 4}px;
        border-right: 1px solid ${palette.neutral['200']};
    `
)

export const StyledNavLink = styled(ButtonNavLink)(
    ({theme: {palette}}) => css`
        &.active {
            background-color: ${palette.primary['500']};
            color: ${palette.neutral.white};
        }

        & svg {
            width: 16px;
            height: 16px;
        }
    `
)
